<template>
  <div>
    <div class="loading-splash">
      <div class="spinner"></div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import store from "@store";
import FooterView from './footer/FooterView.vue'

export default {
  name: 'Main',
  components: {
    FooterView
  },
  data: function () {
    return {
      mounted: false,
      store,
      image: 'https://adwayusa.s3.amazonaws.com/website/lading_page_bg.jpg'
    }
  },
  computed: {
    userRolePath() {
      if (this.$store.getters.user.role == "admin") return '/admin';
      return this.$store.getters.user.role == "driver" ? `/driver` : `/advertiser/dashboard`;
    },
    ready() {
      return this.$auth &&
        this.mounted &&
        !this.$auth.loading &&
        this.$route.path === "/" &&
        Object.keys(this.$route.query).length === 0;
    }
  },
  watch: {
    ready: function(ready) {
      if (ready) {
        if (this.$auth.isAuthenticated) {
          if (this.$store.getters.user) {
            this.$router.push({ path: this.userRolePath });
          } else {
            this.$router.push({ path: `/after-auth` });
          }
        } else {
          this.$router.push({ path: `/login` });
        }
      }
    }
  },
  methods: {
    signIn() {
      this.$auth.loginWithRedirect({
        appState: {
          targetUrl: `after-auth?from=sign-in`,
        },
        authorizationParams: {
          audience: "https://api.adwayusa.com/auth0"
        }
        // authorizationParams: {
        //   redirect_uri: `${window.location.origin}/after-auth`
        // }
      });
    },
    logOut() {
      this.$auth.logout({
        logoutParams: {
          returnTo: process.env.VUE_APP_LOGOUT_REDIRECT
        }
      });
    }
  },
  mounted() {
    this.mounted = true;
  }
}
</script>

<style scoped>

.header {

  position: relative;
  z-index: 100;
  background: linear-gradient(180deg, #0F202F 36.46%, rgba(15, 32, 47, 0) 100%);
  box-shadow: 0px 30px 40px rgba(0, 0, 0, 0.01);
  height: 304px;

}
.header__inner {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  &::before {
    content: "";
  }
}
.header__logo {
  width: 300px;
  height: 38.37px;
  object-fit: contain;
}
.header__actions {
  justify-self: end;
  display: flex;
  gap: 10px;
  font-size: 18px;
  line-height: 20px;
  font-weight: bold;
  text-transform: uppercase;
}

.adway__name {
  margin-top: 18px;
}

.content__image {
  width: 100%;
  height: 100%;
}

.section__positioning {
  margin-top: -270px;
}

.content__name {
  width: 100%;
  height: 304px;
  text-align: center;
  background: rgba(0, 0, 0, 0) linear-gradient(rgb(15, 32, 47) 36.46%, rgba(15, 32, 47, 0) 100%) repeat scroll 0% 0%;
  box-shadow: rgba(0, 0, 0, 0.01) 0px 30px 40px;
  transform: rotate(180deg);
  margin-top: -233px;
  position: relative;
}

.content__name__context {
  width: 100%;
  text-align: center;
  transform: rotate(180deg);
  font-size: 44px;
  line-height: 56px;
}

.footer__style {
  width: 100%; position: relative; bottom: 0; float: left;
}

hr{
  width: 96%;
}
p{
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 0.7em;
  line-height: 20px;
  color: #FFFFFF;
  width: 98%;
  float: left;
  text-align: right;
  margin: 0%;
}

@media only screen and (max-width: 1300px) {

  .section__positioning {
    margin-top: -260px;
  }

}

@media only screen and (max-width: 1100px) {

  .section__positioning {
    margin-top: -240px;
  }

}

@media only screen and (max-width: 1000px) {
  .content__name__context {
    font-size: 40px;
    line-height: 50px;
  }
}

@media only screen and (max-width: 1000px) {
  .content__name__context {
    font-size: 35px;
    line-height: 45px;
  }
}

@media only screen and (max-width: 800px) {
  .section__positioning {
    margin-top: -230px;
  }

  .content__name__context {
    font-size: 30px;
    line-height: 40px;
  }
}

@media only screen and (max-width: 700px) {
  .section__positioning {
    margin-top: -220px;
  }
}

@media only screen and (max-width: 600px) {
  .section__positioning {
    margin-top: -120px;
    margin-left: -330px;
  }

  .header {
    height: 185px
  }

  .content__name {
    margin-top: -200px;
  }

}

@media only screen and (max-width: 500px) {
  .section__positioning {
    margin-left: -250px;
    margin-top: -194px;
  }
}

@media only screen and (max-width: 400px) {
  .section__positioning {
    margin-left: -220px;
  }
}

@media only screen and (max-width: 300px) {
  .header__sing__up {
    top: 45px;
    right: 10px;
  }
}

</style>
